import { getFieldState } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import useFormState from 'src/components/10-atoms/form/hooks/useFormState';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { useCreateSubjectMutation } from 'src/modules/exam-preparation/graphql/subject/create';
import { useUpdateSubjectMutation } from 'src/modules/exam-preparation/graphql/subject/update';
export default function useData(examLevelID, type, subject) {
    const [createMutationState, createMutationActions] = useCreateSubjectMutation();
    const [updateMutationState, updateMutationActions] = useUpdateSubjectMutation();
    const isEditMode = !!subject;
    const [formState, formActions] = useFormState({
        fields: {
            title: getFieldState(subject?.data.title ?? ''),
            description: getFieldState(subject?.data.description ?? ''),
        },
    }, {
        fieldValidations: {
            title({ value }) {
                if (!value || value.trim().length === 0) {
                    return 'Title is required';
                }
                if (value.length > 200) {
                    return 'Title cannot exceed 200 characters';
                }
                return true;
            },
            description({ value }) {
                if (value.length > 500) {
                    return 'Description cannot exceed 500 characters';
                }
                return true;
            },
        },
    });
    const handleSubmit = useStableCallback(() => {
        if (!formActions.validateForm()) {
            return;
        }
        const title = formState.fields.title.value.trim();
        const description = formState.fields.description.value.trim();
        if (isEditMode && subject) {
            updateMutationActions.submit({
                variables: {
                    subjectID: subject.id,
                    data: {
                        title,
                        description,
                    },
                },
                context: {
                    examLevelID,
                    type,
                },
            });
            return;
        }
        createMutationActions.submit({
            variables: {
                examLevelID,
                type,
                data: {
                    title,
                },
            },
        });
    });
    const state = {
        form: formState,
        isEditMode,
        createMutation: createMutationState,
        updateMutation: updateMutationState,
    };
    const actions = {
        form: formActions,
        handleSubmit,
    };
    return [state, actions];
}
